export interface ServiceListItem {
    code: string
    label: string
    group: string
}

export const SERVICE_LIST_ITEMS: ServiceListItem[] = [
    // 1 - Informática
    { code: '1.01', label: 'Análise e desenvolvimento de sistemas', group: '1 - Informática' },
    { code: '1.02', label: 'Programação', group: '1 - Informática' },
    { code: '1.03', label: 'Processamento de dados e congêneres', group: '1 - Informática' },
    { code: '1.04', label: 'Elaboração de programas de computadores', group: '1 - Informática' },
    { code: '1.05', label: 'Licenciamento ou cessão de direito de uso de programas', group: '1 - Informática' },
    { code: '1.06', label: 'Assessoria e consultoria em informática', group: '1 - Informática' },
    { code: '1.07', label: 'Suporte técnico em informática', group: '1 - Informática' },
    { code: '1.08', label: 'Planejamento, confecção e manutenção de páginas eletrônicas', group: '1 - Informática' },

    // 2 - Pesquisas
    { code: '2.01', label: 'Serviços de pesquisas e desenvolvimento', group: '2 - Pesquisas' },

    // 3 - Locação e cessão
    { code: '3.02', label: 'Cessão de direito de uso de marcas e sinais de propaganda', group: '3 - Locação e cessão' },
    { code: '3.03', label: 'Exploração de salões de festas, centros de convenções e congêneres', group: '3 - Locação e cessão' },
    { code: '3.04', label: 'Locação, sublocação, arrendamento de ferrovia, rodovia, postes, cabos', group: '3 - Locação e cessão' },
    { code: '3.05', label: 'Cessão de andaimes, palcos, coberturas e estruturas temporárias', group: '3 - Locação e cessão' },

    // 4 - Saúde
    { code: '4.01', label: 'Medicina e biomedicina', group: '4 - Saúde' },
    { code: '4.02', label: 'Análises clínicas, patologia, eletricidade médica, radiologia', group: '4 - Saúde' },
    { code: '4.03', label: 'Hospitais, clínicas, laboratórios, sanatórios', group: '4 - Saúde' },
    { code: '4.04', label: 'Instrumentação cirúrgica', group: '4 - Saúde' },
    { code: '4.05', label: 'Acupuntura', group: '4 - Saúde' },
    { code: '4.06', label: 'Enfermagem, inclusive serviços auxiliares', group: '4 - Saúde' },
    { code: '4.07', label: 'Serviços farmacêuticos', group: '4 - Saúde' },
    { code: '4.08', label: 'Terapia ocupacional, fisioterapia e fonoaudiologia', group: '4 - Saúde' },
    { code: '4.09', label: 'Terapias de qualquer espécie', group: '4 - Saúde' },
    { code: '4.10', label: 'Nutrição', group: '4 - Saúde' },
    { code: '4.11', label: 'Obstetrícia', group: '4 - Saúde' },
    { code: '4.12', label: 'Odontologia', group: '4 - Saúde' },
    { code: '4.13', label: 'Ortóptica', group: '4 - Saúde' },
    { code: '4.14', label: 'Próteses sob encomenda', group: '4 - Saúde' },
    { code: '4.15', label: 'Psicanálise', group: '4 - Saúde' },
    { code: '4.16', label: 'Psicologia', group: '4 - Saúde' },
    { code: '4.17', label: 'Casas de repouso, creches, asilos e congêneres', group: '4 - Saúde' },
    { code: '4.18', label: 'Inseminação artificial, fertilização in vitro', group: '4 - Saúde' },
    { code: '4.19', label: 'Bancos de sangue, leite, pele, olhos, óvulos, sêmen', group: '4 - Saúde' },
    { code: '4.20', label: 'Coleta de sangue, leite, tecidos, sêmen, órgãos', group: '4 - Saúde' },
    { code: '4.21', label: 'Unidade de atendimento, assistência ou tratamento móvel', group: '4 - Saúde' },
    { code: '4.22', label: 'Planos de medicina de grupo ou individual', group: '4 - Saúde' },
    { code: '4.23', label: 'Outros planos de saúde', group: '4 - Saúde' },

    // 5 - Veterinária
    { code: '5.01', label: 'Medicina veterinária e zootecnia', group: '5 - Veterinária' },
    { code: '5.02', label: 'Hospitais, clínicas, ambulatórios veterinários', group: '5 - Veterinária' },
    { code: '5.03', label: 'Laboratórios de análise na área veterinária', group: '5 - Veterinária' },
    { code: '5.04', label: 'Inseminação artificial, fertilização in vitro (veterinária)', group: '5 - Veterinária' },
    { code: '5.05', label: 'Bancos de sangue e de órgãos (veterinária)', group: '5 - Veterinária' },
    { code: '5.06', label: 'Coleta de sangue, leite, tecidos (veterinária)', group: '5 - Veterinária' },
    { code: '5.07', label: 'Unidade de atendimento móvel (veterinária)', group: '5 - Veterinária' },
    { code: '5.08', label: 'Guarda, tratamento, amestramento, embelezamento, alojamento', group: '5 - Veterinária' },
    { code: '5.09', label: 'Planos de atendimento e assistência médico-veterinária', group: '5 - Veterinária' },

    // 6 - Cuidados pessoais e estética
    { code: '6.01', label: 'Barbearia, cabeleireiros, manicuros, pedicuros', group: '6 - Cuidados pessoais' },
    { code: '6.02', label: 'Esteticistas, tratamento de pele, depilação', group: '6 - Cuidados pessoais' },
    { code: '6.03', label: 'Banhos, duchas, sauna, massagens', group: '6 - Cuidados pessoais' },
    { code: '6.04', label: 'Ginástica, dança, esportes, natação, artes marciais', group: '6 - Cuidados pessoais' },
    { code: '6.05', label: 'Centros de emagrecimento, spa', group: '6 - Cuidados pessoais' },

    // 7 - Engenharia e construção civil
    { code: '7.01', label: 'Engenharia, agronomia, arquitetura, urbanismo, paisagismo', group: '7 - Engenharia' },
    { code: '7.02', label: 'Execução de obras de construção civil', group: '7 - Engenharia' },
    { code: '7.03', label: 'Elaboração de planos diretores, estudos de viabilidade', group: '7 - Engenharia' },
    { code: '7.04', label: 'Demolição', group: '7 - Engenharia' },
    { code: '7.05', label: 'Reparação, conservação e reforma de edifícios, estradas, pontes', group: '7 - Engenharia' },
    { code: '7.06', label: 'Colocação e instalação de tapetes, carpetes, divisórias', group: '7 - Engenharia' },
    { code: '7.07', label: 'Recuperação, raspagem, polimento e lustração de pisos', group: '7 - Engenharia' },
    { code: '7.08', label: 'Calafetação', group: '7 - Engenharia' },
    { code: '7.09', label: 'Varrição, coleta, remoção, reciclagem de lixo e resíduos', group: '7 - Engenharia' },
    { code: '7.10', label: 'Limpeza, manutenção e conservação de vias e imóveis', group: '7 - Engenharia' },
    { code: '7.11', label: 'Decoração e jardinagem', group: '7 - Engenharia' },
    { code: '7.12', label: 'Controle e tratamento de efluentes', group: '7 - Engenharia' },
    { code: '7.13', label: 'Dedetização, desinfecção, higienização, desratização', group: '7 - Engenharia' },
    { code: '7.16', label: 'Florestamento, reflorestamento, semeadura, adubação', group: '7 - Engenharia' },
    { code: '7.17', label: 'Escoramento, contenção de encostas', group: '7 - Engenharia' },
    { code: '7.18', label: 'Limpeza e dragagem de rios, portos, canais', group: '7 - Engenharia' },
    { code: '7.19', label: 'Acompanhamento e fiscalização de obras', group: '7 - Engenharia' },
    { code: '7.20', label: 'Aerofotogrametria, cartografia, mapeamento, topografia', group: '7 - Engenharia' },
    { code: '7.21', label: 'Pesquisa, perfuração de poços, exploração de petróleo e gás', group: '7 - Engenharia' },
    { code: '7.22', label: 'Nucleação e bombardeamento de nuvens', group: '7 - Engenharia' },

    // 8 - Educação
    { code: '8.01', label: 'Ensino regular pré-escolar, fundamental, médio e superior', group: '8 - Educação' },
    { code: '8.02', label: 'Instrução, treinamento, orientação pedagógica', group: '8 - Educação' },

    // 9 - Hospedagem e turismo
    { code: '9.01', label: 'Hospedagem de qualquer natureza em hotéis, motéis, pensões', group: '9 - Hospedagem e turismo' },
    { code: '9.02', label: 'Agenciamento, organização de turismo, viagens, excursões', group: '9 - Hospedagem e turismo' },
    { code: '9.03', label: 'Guias de turismo', group: '9 - Hospedagem e turismo' },

    // 10 - Intermediação
    { code: '10.01', label: 'Agenciamento de câmbio, seguros, cartões de crédito, planos de saúde', group: '10 - Intermediação' },
    { code: '10.02', label: 'Agenciamento de títulos, valores mobiliários', group: '10 - Intermediação' },
    { code: '10.03', label: 'Agenciamento de direitos de propriedade industrial, artística', group: '10 - Intermediação' },
    { code: '10.04', label: 'Agenciamento de leasing, franquia, factoring', group: '10 - Intermediação' },
    { code: '10.05', label: 'Agenciamento de bens móveis ou imóveis', group: '10 - Intermediação' },
    { code: '10.06', label: 'Agenciamento marítimo', group: '10 - Intermediação' },
    { code: '10.07', label: 'Agenciamento de notícias', group: '10 - Intermediação' },
    { code: '10.08', label: 'Agenciamento de publicidade e propaganda', group: '10 - Intermediação' },
    { code: '10.09', label: 'Representação de qualquer natureza', group: '10 - Intermediação' },
    { code: '10.10', label: 'Distribuição de bens de terceiros', group: '10 - Intermediação' },

    // 11 - Guarda e vigilância
    { code: '11.01', label: 'Guarda e estacionamento de veículos, aeronaves, embarcações', group: '11 - Guarda e vigilância' },
    { code: '11.02', label: 'Vigilância, segurança ou monitoramento', group: '11 - Guarda e vigilância' },
    { code: '11.03', label: 'Escolta, inclusive de veículos e cargas', group: '11 - Guarda e vigilância' },
    { code: '11.04', label: 'Armazenamento, depósito, carga, descarga', group: '11 - Guarda e vigilância' },

    // 12 - Diversões e lazer
    { code: '12.01', label: 'Espetáculos teatrais', group: '12 - Diversões e lazer' },
    { code: '12.02', label: 'Exibições cinematográficas', group: '12 - Diversões e lazer' },
    { code: '12.03', label: 'Espetáculos circenses', group: '12 - Diversões e lazer' },
    { code: '12.04', label: 'Programas de auditório', group: '12 - Diversões e lazer' },
    { code: '12.05', label: 'Parques de diversões, centros de lazer', group: '12 - Diversões e lazer' },
    { code: '12.06', label: 'Boates, taxi-dancing', group: '12 - Diversões e lazer' },
    { code: '12.07', label: 'Shows, ballet, danças, desfiles, óperas, concertos, festivais', group: '12 - Diversões e lazer' },
    { code: '12.08', label: 'Feiras, exposições, congressos', group: '12 - Diversões e lazer' },
    { code: '12.09', label: 'Bilhares, boliches e diversões eletrônicas', group: '12 - Diversões e lazer' },
    { code: '12.10', label: 'Corridas e competições de animais', group: '12 - Diversões e lazer' },
    { code: '12.11', label: 'Competições esportivas ou de destreza', group: '12 - Diversões e lazer' },
    { code: '12.12', label: 'Execução de música', group: '12 - Diversões e lazer' },
    { code: '12.13', label: 'Produção de eventos, espetáculos, shows', group: '12 - Diversões e lazer' },
    { code: '12.14', label: 'Fornecimento de música para ambientes', group: '12 - Diversões e lazer' },
    { code: '12.15', label: 'Desfiles de blocos carnavalescos, trios elétricos', group: '12 - Diversões e lazer' },
    { code: '12.16', label: 'Exibição de filmes, musicais, espetáculos, competições', group: '12 - Diversões e lazer' },
    { code: '12.17', label: 'Recreação e animação, inclusive em festas', group: '12 - Diversões e lazer' },

    // 13 - Fonografia, fotografia e reprografia
    { code: '13.02', label: 'Fonografia ou gravação de sons, dublagem, mixagem', group: '13 - Fonografia e fotografia' },
    { code: '13.03', label: 'Fotografia e cinematografia', group: '13 - Fonografia e fotografia' },
    { code: '13.04', label: 'Reprografia, microfilmagem e digitalização', group: '13 - Fonografia e fotografia' },
    { code: '13.05', label: 'Composição gráfica, fotocomposição, litografia', group: '13 - Fonografia e fotografia' },

    // 14 - Bens de terceiros
    { code: '14.01', label: 'Lubrificação, limpeza, revisão, conserto, manutenção de máquinas e veículos', group: '14 - Bens de terceiros' },
    { code: '14.02', label: 'Assistência técnica', group: '14 - Bens de terceiros' },
    { code: '14.03', label: 'Recondicionamento de motores', group: '14 - Bens de terceiros' },
    { code: '14.04', label: 'Recauchutagem ou regeneração de pneus', group: '14 - Bens de terceiros' },
    { code: '14.05', label: 'Restauração, recondicionamento, pintura, lavagem, tingimento', group: '14 - Bens de terceiros' },
    { code: '14.06', label: 'Instalação e montagem de aparelhos e equipamentos', group: '14 - Bens de terceiros' },
    { code: '14.07', label: 'Colocação de molduras', group: '14 - Bens de terceiros' },
    { code: '14.08', label: 'Encadernação, gravação e douração de livros', group: '14 - Bens de terceiros' },
    { code: '14.09', label: 'Alfaiataria e costura', group: '14 - Bens de terceiros' },
    { code: '14.10', label: 'Tinturaria e lavanderia', group: '14 - Bens de terceiros' },
    { code: '14.11', label: 'Tapeçaria e reforma de estofamentos', group: '14 - Bens de terceiros' },
    { code: '14.12', label: 'Funilaria e lanternagem', group: '14 - Bens de terceiros' },
    { code: '14.13', label: 'Carpintaria e serralheria', group: '14 - Bens de terceiros' },

    // 15 - Setor bancário e financeiro
    { code: '15.01', label: 'Administração de fundos, consórcio, cartão de crédito', group: '15 - Bancário e financeiro' },
    { code: '15.02', label: 'Abertura de contas em geral', group: '15 - Bancário e financeiro' },
    { code: '15.03', label: 'Locação e manutenção de cofres e terminais', group: '15 - Bancário e financeiro' },
    { code: '15.04', label: 'Fornecimento de atestados em geral', group: '15 - Bancário e financeiro' },
    { code: '15.05', label: 'Cadastro, elaboração de ficha cadastral', group: '15 - Bancário e financeiro' },
    { code: '15.06', label: 'Emissão de avisos, comprovantes e documentos', group: '15 - Bancário e financeiro' },
    { code: '15.07', label: 'Acesso e consulta a contas em geral', group: '15 - Bancário e financeiro' },
    { code: '15.08', label: 'Emissão e registro de contrato de crédito', group: '15 - Bancário e financeiro' },
    { code: '15.09', label: 'Arrendamento mercantil (leasing)', group: '15 - Bancário e financeiro' },
    { code: '15.10', label: 'Cobranças, recebimentos ou pagamentos em geral', group: '15 - Bancário e financeiro' },
    { code: '15.11', label: 'Devolução de títulos, protesto de títulos', group: '15 - Bancário e financeiro' },
    { code: '15.12', label: 'Custódia de títulos e valores mobiliários', group: '15 - Bancário e financeiro' },
    { code: '15.13', label: 'Operações de câmbio em geral', group: '15 - Bancário e financeiro' },
    { code: '15.14', label: 'Fornecimento de cartão magnético, crédito, débito', group: '15 - Bancário e financeiro' },
    { code: '15.15', label: 'Compensação de cheques e títulos', group: '15 - Bancário e financeiro' },
    { code: '15.16', label: 'Emissão de ordens de pagamento, transferência de valores', group: '15 - Bancário e financeiro' },
    { code: '15.17', label: 'Emissão e oposição de cheques', group: '15 - Bancário e financeiro' },
    { code: '15.18', label: 'Serviços de crédito imobiliário', group: '15 - Bancário e financeiro' },

    // 16 - Transporte municipal
    { code: '16.01', label: 'Serviços de transporte de natureza municipal', group: '16 - Transporte municipal' },

    // 17 - Apoio técnico e administrativo
    { code: '17.01', label: 'Assessoria ou consultoria de qualquer natureza', group: '17 - Apoio técnico' },
    { code: '17.02', label: 'Datilografia, digitação, estenografia, secretaria em geral', group: '17 - Apoio técnico' },
    { code: '17.03', label: 'Planejamento, coordenação, programação técnica ou administrativa', group: '17 - Apoio técnico' },
    { code: '17.04', label: 'Recrutamento, agenciamento, seleção de mão-de-obra', group: '17 - Apoio técnico' },
    { code: '17.05', label: 'Fornecimento de mão-de-obra', group: '17 - Apoio técnico' },
    { code: '17.06', label: 'Propaganda e publicidade', group: '17 - Apoio técnico' },
    { code: '17.08', label: 'Franquia (franchising)', group: '17 - Apoio técnico' },
    { code: '17.09', label: 'Perícias, laudos, exames técnicos', group: '17 - Apoio técnico' },
    { code: '17.10', label: 'Planejamento e administração de feiras, exposições, congressos', group: '17 - Apoio técnico' },
    { code: '17.11', label: 'Organização de festas e recepções, bufê', group: '17 - Apoio técnico' },
    { code: '17.12', label: 'Administração em geral, inclusive de bens de terceiros', group: '17 - Apoio técnico' },
    { code: '17.13', label: 'Leilão', group: '17 - Apoio técnico' },
    { code: '17.14', label: 'Advocacia', group: '17 - Apoio técnico' },
    { code: '17.15', label: 'Arbitragem de qualquer espécie', group: '17 - Apoio técnico' },
    { code: '17.16', label: 'Auditoria', group: '17 - Apoio técnico' },
    { code: '17.17', label: 'Análise de Organização e Métodos', group: '17 - Apoio técnico' },
    { code: '17.18', label: 'Atuária e cálculos técnicos', group: '17 - Apoio técnico' },
    { code: '17.19', label: 'Contabilidade, inclusive serviços técnicos e auxiliares', group: '17 - Apoio técnico' },
    { code: '17.20', label: 'Consultoria e assessoria econômica ou financeira', group: '17 - Apoio técnico' },
    { code: '17.21', label: 'Estatística', group: '17 - Apoio técnico' },
    { code: '17.22', label: 'Cobrança em geral', group: '17 - Apoio técnico' },
    { code: '17.23', label: 'Assessoria e administração de contas, factoring', group: '17 - Apoio técnico' },
    { code: '17.24', label: 'Apresentação de palestras, conferências, seminários', group: '17 - Apoio técnico' },

    // 18 - Seguros
    { code: '18.01', label: 'Regulação de sinistros, inspeção e avaliação de riscos', group: '18 - Seguros' },

    // 19 - Loteria
    { code: '19.01', label: 'Distribuição e venda de bilhetes de loteria, bingos, apostas', group: '19 - Loteria' },

    // 20 - Serviços portuários e aeroportuários
    { code: '20.01', label: 'Serviços portuários, ferroportuários', group: '20 - Portuários' },
    { code: '20.02', label: 'Serviços aeroportuários', group: '20 - Portuários' },
    { code: '20.03', label: 'Serviços de terminais rodoviários, ferroviários, metroviários', group: '20 - Portuários' },

    // 21 - Registros públicos
    { code: '21.01', label: 'Serviços de registros públicos, cartorários e notariais', group: '21 - Registros públicos' },

    // 22 - Exploração de rodovia
    { code: '22.01', label: 'Exploração de rodovia mediante pedágio', group: '22 - Exploração de rodovia' },

    // 23 - Comunicação visual
    { code: '23.01', label: 'Programação e comunicação visual, desenho industrial', group: '23 - Comunicação visual' },

    // 24 - Chaveiros e sinalização
    { code: '24.01', label: 'Chaveiros, confecção de carimbos, placas, sinalização, banners', group: '24 - Chaveiros e sinalização' },

    // 25 - Funerários
    { code: '25.01', label: 'Funerais, transporte do corpo, caixão, urna', group: '25 - Funerários' },
    { code: '25.02', label: 'Cremação de corpos', group: '25 - Funerários' },
    { code: '25.03', label: 'Planos ou convênio funerários', group: '25 - Funerários' },
    { code: '25.04', label: 'Manutenção e conservação de jazigos e cemitérios', group: '25 - Funerários' },

    // 26 - Coleta e entrega
    { code: '26.01', label: 'Coleta, remessa ou entrega de correspondências, courrier', group: '26 - Coleta e entrega' },

    // 27 - Assistência social
    { code: '27.01', label: 'Serviços de assistência social', group: '27 - Assistência social' },

    // 28 - Avaliação de bens
    { code: '28.01', label: 'Avaliação de bens e serviços de qualquer natureza', group: '28 - Avaliação' },

    // 29 - Biblioteconomia
    { code: '29.01', label: 'Serviços de biblioteconomia', group: '29 - Biblioteconomia' },

    // 30 - Biologia e química
    { code: '30.01', label: 'Biologia, biotecnologia e química', group: '30 - Biologia e química' },

    // 31 - Serviços técnicos
    { code: '31.01', label: 'Serviços técnicos em edificações, eletrônica, mecânica, telecomunicações', group: '31 - Serviços técnicos' },

    // 32 - Desenhos técnicos
    { code: '32.01', label: 'Serviços de desenhos técnicos', group: '32 - Desenhos técnicos' },

    // 33 - Desembaraço aduaneiro
    { code: '33.01', label: 'Desembaraço aduaneiro, comissários, despachantes', group: '33 - Desembaraço aduaneiro' },

    // 34 - Investigações
    { code: '34.01', label: 'Investigações particulares, detetives', group: '34 - Investigações' },

    // 35 - Imprensa e relações públicas
    { code: '35.01', label: 'Reportagem, assessoria de imprensa, jornalismo, relações públicas', group: '35 - Imprensa' },

    // 36 - Meteorologia
    { code: '36.01', label: 'Serviços de meteorologia', group: '36 - Meteorologia' },

    // 37 - Artistas e modelos
    { code: '37.01', label: 'Serviços de artistas, atletas, modelos e manequins', group: '37 - Artistas' },

    // 38 - Museologia
    { code: '38.01', label: 'Serviços de museologia', group: '38 - Museologia' },

    // 39 - Ourivesaria
    { code: '39.01', label: 'Ourivesaria e lapidação', group: '39 - Ourivesaria' },

    // 40 - Obras de arte
    { code: '40.01', label: 'Obras de arte sob encomenda', group: '40 - Obras de arte' },
]
